import React from 'react';
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Stack } from "@mui/material";
const DocumentFooterSkeleton = () => {
  return <Box sx={{
    w: '100%',
    p: 2
  }}>
            <Box sx={{
      mb: 2
    }}>
                <Skeleton variant="rectangular" width={200} height={32} sx={{
        borderRadius: 1
      }} />
            </Box>

            <TableContainer component={Paper} variant="outlined" sx={{
      borderRadius: 1.5
    }}>
                <Table size="small">
              <TableHead>
                <TableRow>
                  {(Array.from({
              length: 5
            }) && Array.from({
              length: 5
            }).length > 0 ? Object.keys(Array.from({
              length: 5
            })[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(Array.from({
            length: 5
          }) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                          {String(displayVal)}
                        </TableCell>;
            })}
                  </TableRow>)}
              </TableBody>
            </Table>
            </TableContainer>
        </Box>;
};
export default DocumentFooterSkeleton;